module.exports = __webpack_public_path__ + "public/adminIcons/documentVerification.svg?7cbe0bc9";